module.exports = __webpack_public_path__ + "img/levelup-icon-budget-document.6484f476.svg";